import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-card',
  templateUrl: './review-card.component.html',
  styleUrls: ['./review-card.component.scss'],
})
export class ReviewCardComponent implements OnInit {
  @Input('type') reviewType!: string;
  @Input() discriptionOne!: string;
  @Input() discriptionTwo!: string;
  @Input() disable!: boolean;
  @Input() buttonText!: string;
  @Input('link') navigationLink!: string;
  constructor() {}

  ngOnInit(): void {}
}
